import React from 'react';
import { DefaultDatePicker } from '../../../global/default-datepicker/default-datepicker';
import { connectZoomVM } from '../../zoom.context';
import DefaultButton from '../../../global/default-button/default-button';
import { DateFnsFormats } from '../../../../infrastructure/date-formatter';
import { FormField } from '../../../global/form/form-field/form-field';
import './scheduled-date-actions.scss';
import { SearchInput } from '../../../global/search-input/search-input';

interface IZoomScheduledDatesProps {
    setStartDateTime: (newDate: Date) => void;
    setEndDateTime: (newDate: Date) => void;
    startDateTime: Date;
    endDateTime: Date;
    reFetchScheduledMeetings: () => void;
    isNeedRefetch: boolean;
    minEndTime: Date;
    searchQuery: string;
    handleChangeSearchQuery: (query: string) => void;
    getFilteredScheduledMeetings: () => void;
    clear: () => void;
    maxStartTime: Date;
 }

const defaultProps = {
    showTimeSelect: true,
    isClearable: true,
    dateFormat: DateFnsFormats.NumericDateTime12Hours,
    timeIntervals: 60,
    strictParse: true
};

const ScheduledZoomMeetingsDateFilterPresentation = (props: IZoomScheduledDatesProps) => {
    const { startDateTime, endDateTime } = props;

    if (props.isNeedRefetch) {
        props.reFetchScheduledMeetings();
    }

    return (
        <div className='schedued-date-actions'>
            <form className='oe-form'>
                <div className='oe-form__body'>
                    <FormField label='Start Date and time'>
                        <DefaultDatePicker
                            selected={startDateTime}
                            onChange={date => props.setStartDateTime(date)}
                            placeholderText='Select start date time'
                            maxDate={props.maxStartTime}
                            className='oe-form-field__control'
                            {...defaultProps}
                        />
                    </FormField>

                    <FormField label='End Date and time'>
                        <DefaultDatePicker
                            selected={endDateTime}
                            onChange={date => props.setEndDateTime(date)}
                            placeholderText='Select end date time'
                            minDate={props.minEndTime}
                            maxDate={null}
                            className='oe-form-field__control'
                            {...defaultProps}
                        />
                    </FormField>

                    <FormField label='Search Query'>
                        <div className='search-input-container'>
                            <SearchInput
                                onChange={e => props.handleChangeSearchQuery(e.target.value)}
                                onEnterButtonDown={props.getFilteredScheduledMeetings}
                                placeholder='Enter search term'
                                withResetSearchButton={!!props.searchQuery}
                                resetSearch={() => props.handleChangeSearchQuery('')}
                                value={props.searchQuery}
                            />
                        </div>
                    </FormField>
                </div>

                <div className='oe-form__footer'>
                    <div className='buttons-block'>
                        <DefaultButton
                            onClick={props.getFilteredScheduledMeetings}
                            text='Filter Zoom Meetings Schedule'
                            modifier='fat'
                        />
                        <DefaultButton
                            onClick={props.clear}
                            text='Clear Filter Fields'
                            modifier='fat'
                        />
                    </div>
                </div>
            </form>
        </div>
    );
};

const ScheduledZoomMeetingsDateFilter = connectZoomVM<IZoomScheduledDatesProps>(ScheduledZoomMeetingsDateFilterPresentation, zoomVM => {
    const vm = zoomVM.getScheduledMeetingsVM();

    return {
        setStartDateTime: vm.setStartTime.bind(vm),
        setEndDateTime: vm.setEndTime.bind(vm),
        startDateTime: vm.getStartTime(),
        endDateTime: vm.getEndTime(),
        isNeedRefetch: vm.isNeedRefetch(),
        reFetchScheduledMeetings: vm.reFetchMeetings,
        minEndTime: vm.getMinEndTime(),
        searchQuery: vm.getSearchQuery(),
        handleChangeSearchQuery: vm.handleChangeSearchQuery,
        getFilteredScheduledMeetings: vm.getFilteredScheduledMeetings,
        clear: vm.cleanRecources,
        maxStartTime: vm.getMaxStartTime()
    };
});

export { ScheduledZoomMeetingsDateFilter, ScheduledZoomMeetingsDateFilterPresentation };